import { request, headers, API_BASE_URL } from './apiClient'

export function fetchProjects() {
  return request('GET', '/v1/projects/')
}

export function createProject(message) {
  return request('POST', '/v1/projects/', { message })
}

export function fetchProject(id) {
  return request('GET', `/v1/projects/${id}/`)
}

export function updateAnswers(id, deltaAnswers) {
  return request('PATCH', `/v1/projects/${id}/answers/`, { answers: deltaAnswers })
}

export function renameProject(id, title) {
  return request('PATCH', `/v1/projects/${id}/`, { title })
}

export function deleteProject(id) {
  return request('DELETE', `/v1/projects/${id}/`)
}

export function fetchBriefFeedbacks(projectId) {
  return request('GET', `/v1/projects/${projectId}/brief_feedback/`)
}

export function submitBriefFeedback(projectId, rating, text, openTicket = false) {
  return request('POST', `/v1/projects/${projectId}/brief_feedback/`, {
    rating,
    text,
    open_ticket: openTicket,
  })
}

export async function generateBrief(id, { onChunk, onDone, onError, onStockMatch } = {}) {
  const response = await fetch(`${API_BASE_URL}/v1/projects/${id}/generate_brief/`, {
    method: 'POST',
    headers: headers(),
  })

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || `Erreur HTTP ${response.status}`)
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder('utf-8')
  // SSE frames can be split across network reads (the stock_match frame
  // carries the whole material list), so keep the incomplete tail buffered.
  let pending = ''

  const handleFrame = (frame) => {
    const line = frame.trim()
    if (!line.startsWith('data:')) return
    const raw = line.replace(/^data:\s*/, '').trim()
    if (!raw || raw === 'end') return
    let parsed
    try {
      parsed = JSON.parse(raw)
    } catch {
      return
    }
    if (parsed.text !== undefined) {
      onChunk?.(parsed.text)
    } else if (parsed.done) {
      onDone?.()
    } else if (parsed.event === 'stock_match') {
      onStockMatch?.(parsed)
    } else if (parsed.error) {
      onError?.(parsed.error)
    }
  }

  for (;;) {
    const { value, done } = await reader.read()
    if (done) break
    pending += decoder.decode(value, { stream: true })
    const frames = pending.split('\n\n')
    pending = frames.pop()
    frames.forEach(handleFrame)
  }
  pending += decoder.decode()
  if (pending) handleFrame(pending)
}
